module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-11-80fc95e4fb29ab67b14d1f03d9126c03.jpg";